import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';
import type { Competitor, Item } from '@/components/project/selectorCompetitors/types';

export const useItemsFromCompetitors = (competitors: MaybeRefOrGetter<Competitor[]>, projectId: MaybeRefOrGetter<number>) => {
	return computed(() => {
		const activeCompetitors = toValue(competitors).filter(competitor => competitor.on >= 0 || competitor.id === projectId);

		const items: Item[] = activeCompetitors.map(competitor => {
			return {
				value: competitor.id,
				title: competitor.url + ` [${competitor.id}]`,
				icon: competitor.id === toValue(projectId) ? '' : '',
				content: competitor.name,
			};
		});

		return items;
	});
};
